'use client';

import type { BusinessQuickCategoryItemType } from '@weberus/shared-types';
import type { Optional } from '@/app/_shared/types';
import { useEffect, type FC } from 'react';
import { useInView } from 'react-intersection-observer';
import { BaseImage } from '@/app/_components/common/base-image';
import BusinessQuickCategoryBadge from '@/app/_components/widgets/business-quick-category/ui/business-quick-category-badge';
import { cn } from '@/app/_shared/utils/tw-cn';

interface BusinessQuickCategoryItemProps extends Optional<BusinessQuickCategoryItemType, 'serverLogMeta'> {
  onClick?: (ev: React.MouseEvent<HTMLAnchorElement>) => void;
  onImpressed?: () => void;
}

export const BusinessQuickCategoryItem: FC<BusinessQuickCategoryItemProps> = ({
  badge,
  action,
  title,
  image,
  onClick,
  onImpressed,
}) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inView) {
      onImpressed?.();
    }
  }, [inView]);

  return (
    <a ref={ref} href={action.web} className="w-68 pc:w-92" onClick={(ev) => onClick?.(ev)}>
      <div className="relative flex flex-col items-center justify-center gap-4 pc:gap-8">
        <span className="relative size-48 pc:size-72">
          <BaseImage alt="" className="size-full" src={image.url} />
        </span>
        {!!badge && <BusinessQuickCategoryBadge title={badge.title} />}
        <span
          className={cn(
            'w-68 justify-center whitespace-nowrap text-center text-text-neutral-main pc:w-92',
            title.length > 6
              ? 'translate-y-0.5 typography-body-12-regular-fixed pc:translate-y-0 pc:text-[15px] pc:font-normal pc:leading-[19px]'
              : 'typography-body-13-regular-fixed pc:typography-subtitle-16-regular-fixed',
          )}>
          {title}
        </span>
      </div>
    </a>
  );
};
